import { OTHER_VIEW, OTHER_ADD, OTHER_EDIT } from '@/fixtures'

export default {
  path: 'bup-other',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Other',
      component: () => import('@/views/menus/Other/Index'),
      meta: {
        permission: OTHER_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Other BUP',
      component: () => import('@/views/menus/Other/Form'),
      meta: {
        permission: OTHER_VIEW
      }
    },
    {
      path: 'create',
      name: 'Add Other BUP',
      component: () => import('@/views/menus/Other/Form'),
      meta: {
        permission: OTHER_ADD
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Other BUP',
      component: () => import('@/views/menus/Other/Form'),
      meta: {
        permission: OTHER_EDIT
      }
    }
  ]
}
